import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AirportmapviewPage } from '../airportmapview/airportmapview.page';

@Component({
    selector: 'airportdetailscard',
    templateUrl: './airportdetailscard.component.html',
    styleUrls: ['./airportdetailscard.component.scss'],
    standalone: false
})
export class AirportdetailscardComponent implements OnInit {
  @Input('airportinfo') public airportInfo: any;
  public freq: string = 'AirportFrequencies';
  constructor(private modalCtrl: ModalController,
    private alertCtrl:AlertController
   ) { }
  public ngOnInit() {
  }
   public async loadMapView() {
    if(this.airportInfo.AirportFrequencies && ( this.airportInfo.AirportFrequencies!=null || this.airportInfo.AirportFrequencies!=undefined))
    {
      const latLongData = {
        lat: this.airportInfo.ReferencePosition.Latitude,
        lng: this.airportInfo.ReferencePosition.Longitude,
        icao: this.airportInfo.ICAOCode
      }
      const modal = await this.modalCtrl.create({
        component: AirportmapviewPage,
        componentProps: {
          data: latLongData,
          airportInfo:this.airportInfo
        }
      });
      modal.present();
    }
    else
    {
      const alert = await this.alertCtrl.create({
        header: 'Alert!',
        subHeader: 'Data is not available',
        buttons: ['OK'],
      });
      alert.present();
    }
  }
}
